

//ruoter中 为了区分pc和移动端 在移动端最后写为/wap
//在routerjs中路由守卫中兼容
const lingyunge = [
    {
        path: "/lingyunge",
        name: "lingyunge",
        meta: {
            title: '凌云阁积分排行榜',
        },
        component: () => import("../../pages/lingyunge/lingyungePc/index.vue")
    },
    {
        path: "/lingyunge/wap",
        name: "lingyunge/wap",
        meta: {
            title: '凌云阁积分排行榜',
        },
        component: () => import("../../pages/lingyunge/lingyungeMobile/index.vue")
    }
]

export default lingyunge;